import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGIN } from 'store';
import { Link, Redirect } from 'react-router-dom';
import { Form, Button, Alert, Row, Col, Container, InputGroup, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import LoginService from '../../services/login';
import * as logo from "../../images/logo-dark.png";
import * as logoWhite from "../../images/logo-branco-scan.png";
import { CompanyType } from '../../helpers/Enum/index';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import './style.scss';

const ForgottenPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({show:false,error:false});
  const [isLoad, setLoad] = useState(false);

  var hidden = true;

  const { t } = useTranslation();

  const submit = (email) => {
    setLoad(true);
    setMessage({...{show:false, error:false}});
    let response = LoginService.forgotten_password(email);
    response.then((data) => {
      setMessage({...{show:true, error:false}});
      setLoad(false);
    }).catch((error) => {
      if(error.response.status === 404){
        setMessage({...{show:true, error:true}});
      }else{
        console.erro(error.response);
      }
      setLoad(false);
    });
  }
  const minWidth = 940;
  const isMobile = window.innerWidth <= minWidth;

  return (
    <>
    <div className={isMobile?"bg-scansource pl-3":''} style={{height:'100vh'}}>
      <Row className={isMobile?"bg-scansource p-3":''} style={{height:'100vh'}}>
        <Col md="5" className={(isMobile?'':'p-5')+" col-login"} style={{background:'white'}}>
          <div className="scan-logo">
            <span>
              <img src={logo} alt="ScanSource" width={!isMobile?"250":'200'} />
            </span>
          </div>
          <div className="login-text">
            <h5 className="login-h5">Esqueceu a senha</h5>
            <span className="login-span">Digite seu e-mail e enviaremos as instruções para redefinir sua senha.</span>
          </div>
          <Container className="pl-5 pr-5">
            {message.show?(
              <Alert variant={message.error?"danger":"success"}>
                {message.error?"Esse E-mail não foi encontrado":"E-mail enviado"}
              </Alert>
            ):''}
          </Container>
          <Form className="login-form"
            onSubmit={e => {
              e.preventDefault();
              submit(email);
            }}
          >
            <Form.Group>
              <Form.Label className="form-label">{t('label:email')}</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <MailOutlineIcon className="icon-input" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="email"
                  onChange={e => setEmail(e.target.value)}
                  className="input-size"
                  required
                />
              </InputGroup>
            </Form.Group>
            {isLoad?(
              <p className="text-center mt-2">
              <Spinner animation="border" style={{color:'#e05c17'}}/>
              </p>
            ):(
            <Button block type="submit" className="login-btn">
            Lembrar Acesso
            </Button>
            )}
            <p className="text-center mt-2">
              <Link to="/login" className="forgot-password">
                Voltar ao Login
              </Link>
            </p>
          </Form>
        </Col>
        {!isMobile?(
          <Col md="7" className="bg-scansource">
            {/* <div className="scan-logo-white">
              <span>
                <img src={logoWhite} alt="ScanSource" width="250" />
              </span>
            </div>
            <div className="scan-site mt-3">
              <span>
                www.scansource.com.br
              </span>
            </div> */}
          </Col>
        ):''}
      </Row>
      </div>
    </>
  );
};

export default ForgottenPassword;